import { GenericTextStyle } from './styles';

const GenericText = ({ ...props }: any) => {
  return <GenericTextStyle {...props} />;
};

export default GenericText;
